import { render, staticRenderFns } from "./gasto-ia.vue?vue&type=template&id=01300164&scoped=true"
import script from "./gasto-ia.vue?vue&type=script&lang=js"
export * from "./gasto-ia.vue?vue&type=script&lang=js"
import style0 from "./gasto-ia.vue?vue&type=style&index=0&id=01300164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01300164",
  null
  
)

export default component.exports